import MaterialListItemIcon, {
    ListItemIconProps,
} from '@mui/material/ListItemIcon';

export function ListItemIcon(props: ListItemIconProps) {
    return (
        <MaterialListItemIcon
            data-testid={'ListItemIcon-container'}
            {...props}
        ></MaterialListItemIcon>
    );
}

export default ListItemIcon;
